//
//
//
//
//
//

import { mapActions } from 'vuex'
import { ACTION_UPDATE_GOOGLE_MAP_DATA } from '@/scripts/store/actions'
import { config } from './google-maps-config'
import wcs from '@/scripts/libs/wcs'

import { centerGoogleMapUsingLocation, initializeGoogleMaps } from '@/scripts/libs/google-maps'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'

const { locale } = wcs.getStoreConfig()

export default {
  name: 'rb-google-maps',
  props: {
    overrideLocale: {
      type: String,
      default: locale,
    },
  },
  data() {
    return {
      map: null,
    }
  },
  mounted() {
    this.initializeMap()
  },
  methods: {
    ...mapActions({
      updateGoogleMapData: ACTION_UPDATE_GOOGLE_MAP_DATA,
    }),
    initializeMap() {
      const mapDiv = this.$refs.googleMap
      const countryCode = this.mapCountryCode(this.overrideLocale)

      initializeGoogleMaps(mapDiv, config, countryCode, (map, results) => {
        this.map = map

        centerGoogleMapUsingLocation(this.map, results[0].geometry.location)
        this.updateGoogleMapData({ map: this.map })
        this.$emit('googleMapLoaded', this.map)
      })
    },
    // TODO: Extract this method in WcsLocales
    mapCountryCode(locale) {
      if (locale === WcsLocales.IT_IT) {
        return 'italy'
      } else if (locale === WcsLocales.EN_FI) {
        return 'finland'
      } else {
        return WcsLocales.mapCountryCode(locale)
      }
    },
  },
}
